<app-carousel></app-carousel>
<div class="p-md-4">
  <app-company-list></app-company-list>
</div>